import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";

const ConfirmationScreen = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!state?.isCompleted) {
      navigate("/services");
      return;
    }
  });
  return (
    <>
      <Header />
      <section className="mt-5 pt-5 mb-5 pb-5">
        <div className="container">
          <div className="form_box p-5 text-center">
            <i className="fa fa-check-circle-o confrim" />
            <h1 className=" pb-4 pt-4">
              Thank you for booking with us. We look forward to serving you
              soon.
            </h1>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};
export default ConfirmationScreen;
